import React from 'react'
import { connect } from 'react-redux'

import { PHCont } from './styled'
import { StdCard } from 'components'
import { ProcessRow } from './ProcessRow'

const PRProcessHistory = props => {
  const { sapDetails } = props
  return (
    <PHCont>
      <StdCard title="Comment History" style={{ flex: 1 }}>
        {sapDetails &&
          sapDetails.rfqComments.map((item, i) => {
            let files = sapDetails.rfqAttachments.filter(x=>x.commentId===item.id)
            return <ProcessRow data={item} files={files} />
          })}
      </StdCard>
    </PHCont>
  )
}

const mapStateToProps = state => {
  return {
    sapDetails: state.rfq.sapDetails.data
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(PRProcessHistory)
